export const LayerTypeEnum = Object.freeze({
  TimberFrameLayer: 'timber-frame-layer' as LayerType,
  TimberFrameLayerWall: 'timber-frame-layer-wall' as LayerType,
  TimberFrameLayerRoofCeiling: 'timber-frame-layer-roof-ceiling' as LayerType,
  CLTLayer: 'clt-assembly-layer' as LayerType,
  ProductLayer: 'product-layer' as LayerType,
  PlateLayer: 'plate-layer' as LayerType,
})

export const AssemblyKind = Object.freeze({
  TimberFrame: 'timber-frame-assembly' as AssemblyKind,
  TimberFrameWall: 'timber-frame-assembly-wall' as AssemblyKind,
  TimberFrameRoof: 'timber-frame-assembly-roof' as AssemblyKind,
  TimberFrameCeiling: 'timber-frame-assembly-ceiling' as AssemblyKind,
  CLT: 'clt-assembly' as AssemblyKind,
  CLTRoof: 'clt-assembly-roof' as AssemblyKind,
  CLTCeiling: 'clt-assembly-ceiling' as AssemblyKind,
})

export const AssemblyTypeEnum = Object.freeze({
  Inner: 'Inner' as AssemblyTypes,
  Outer: 'Outer' as AssemblyTypes,
  Ceiling: 'Ceiling' as AssemblyTypes,
  Roof: 'Roof' as AssemblyTypes,
})
